export interface CropRect {
  /** All fields are fractions of the image's natural width/height, 0..1 */
  x: number
  y: number
  w: number
  h: number
}

export const FULL_CROP_RECT: CropRect = {x: 0, y: 0, w: 1, h: 1}

/** Crops an image to `rect` (fractions of natural size) and returns a freshly
 * loaded HTMLImageElement backed by the cropped pixels — replaces the working
 * source image, so every downstream format conversion sees the cropped result. */
export const cropImage = (image: HTMLImageElement, rect: CropRect): Promise<HTMLImageElement> => {
  const naturalW = image.naturalWidth || image.width
  const naturalH = image.naturalHeight || image.height
  const cropX = Math.round(rect.x * naturalW)
  const cropY = Math.round(rect.y * naturalH)
  const cropW = Math.max(1, Math.round(rect.w * naturalW))
  const cropH = Math.max(1, Math.round(rect.h * naturalH))

  const canvas = document.createElement('canvas')
  canvas.width = cropW
  canvas.height = cropH
  const ctx = canvas.getContext('2d')
  if (!ctx) return Promise.reject(new Error('Canvas 2D context unavailable'))
  ctx.drawImage(image, cropX, cropY, cropW, cropH, 0, 0, cropW, cropH)

  return new Promise((resolve, reject) => {
    const cropped = new Image()
    cropped.onload = () => resolve(cropped)
    cropped.onerror = () => reject(new Error('Failed to load cropped image'))
    cropped.src = canvas.toDataURL('image/png')
  })
}
